/* em-product.js - the product page's behaviour, ported from the prototype's
   product/index.html: the gallery, the size and its price, Add to Bag into
   Shopify's cart, the long copy trimmed of the sentence the page already said,
   the video slot, the generator's own words, Complete the practice and Goes
   with this from Shopify's product recommendations. */
(function () {
  'use strict';
  var P = window.EM_PRODUCT; if (!P) return;
  var host = document.getElementById('pdp'); if (!host) return;

  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  /* Shopify's money formats, thousands included ("$2,563.76" beside a "$2,500.00" price - independent check), and
     "$68.88" as on the cards (the store's format has a space after the $) */
  function money(cents) {
    var f = String(P.money || '${{amount}}').replace(/<[^>]+>/g, ''), n = Number(cents) / 100;
    function fmt(d, th, dec) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dec); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(2, ' ', '.');
        default: return fmt(2, ',', '.');
      }
    }).replace(/^\$\s+/, '$');
  }

  /* ---- the generator pieces. Every string that is not markup is theirs. */
  /* Sept 29: the eighth generator has no single hz -- it cycles three wealth codes -- so it is
     keyed by handle. hz still wins, so the seven tone devices resolve exactly as before. */
  var G = (window.EM_GEN && (window.EM_GEN[P.hz] || window.EM_GEN[P.handle])) || null;
  var GF = (G && window.EM_FREQ_BY) ? EM_FREQ_BY.hz(P.hz) : null;
  if (GF) { host.style.setProperty('--tone', GF.tone); host.style.setProperty('--soft', GF.soft); }
  function li(t) { return '<li>' + t + '</li>'; }
  function genTitle(t) {
    var i = t.indexOf(' for ');
    return i < 0 ? esc(t) : esc(t.slice(0, i)) + '<span class="pfor">' + esc(t.slice(i + 1)) + '</span>';
  }
  function threeLine(w) { return w.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join(' '); }
  function introHTML(t) {
    var m = t.match(/(?:[^.!?]|\.(?=\d))+[.!?]+(?:\s+|$)/g) || [t];
    var head = m.slice(0, 2).join(''), tail = m.slice(2).join('');
    return head + (tail ? '<span class="srest">' + tail + '</span>' : '');
  }
  function panel(id, title, inner) {
    return '<details class="ppanel" id="' + id + '"><summary><span>' + title + '</span></summary><div class="pbody">' + inner + '</div></details>';
  }
  function genDetails() {
    var D = window.EM_GEN_DEVICE || {};
    var rows = [['Frequency', G.freq || ('Fixed at ' + P.hz + 'Hz. Nothing to tune.')]];
    if (D.field) rows.push(['Field', D.field]);
    if (D.range) rows.push(['Range', D.range]);
    if (G.detail) rows.push(G.detail);
    if (D.power) rows.push(['Power', D.power]);
    if (D.light) rows.push(['Indicator light', D.light]);
    if (D.switch) rows.push(['Switch', D.switch]);
    rows.push(['Setup', G.setup || 'Switch it on and leave it. It holds one frequency and stays there.']);
    rows.push(['Note', 'Not a medical device, and not a substitute for professional care.']);
    return rows;
  }
  function genPanels() {
    var why = G.why.map(function (b) { return Array.isArray(b) ? '<ul>' + b.map(li).join('') + '</ul>' : '<p>' + b + '</p>'; }).join('');
    /* Oct 16: 432's copy gives one flat list of benefits, which belongs in the points
       above rather than split into label and gloss. Same reasoning as the rooms block
       below - a heading over an empty list reads as a mistake - so the panel is conditional. */
    var hasBen = !!(G.benefits && G.benefits.length);
    var ben = hasBen ? '<ul class="bl">' + G.benefits.map(function (r) { return '<li><b>' + r[0] + '</b>' + r[1] + '</li>'; }).join('') + '</ul>' : '';
    var det = '<dl>' + genDetails().map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('') + '</dl>';
    return panel('p-why', G.whyTitle || ('Why ' + P.hz + 'Hz?'), why) + (hasBen ? panel('p-ben', 'Benefits you can feel', ben) : '') + panel('p-det', 'Details', det);
  }
  function placeBand() {
    /* Sept 29: their copy for the Wealth Codes has no where-to-place list, and an eyebrow over an
       empty row reads as a mistake. The rooms block is conditional; the Pro tip is not. */
    var rooms = '';
    if (G.place && G.place.length) {
      var withWhy = G.place.every(function (r) { return r[1]; });
      rooms = '<span class="eyebrow">Where to place it</span>'
        + '<div class="rooms' + (withWhy ? '' : ' chips') + '">'
        + G.place.map(function (r) { return '<div class="room"><b>' + r[0] + '</b>' + (r[1] ? '<span>' + r[1] + '</span>' : '') + '</div>'; }).join('')
        + '</div>';
    }
    return '<div class="place">' + rooms + (G.tip ? '<p class="tip"><b>Pro tip</b>' + G.tip + '</p>' : '') + '</div>';
  }
  if (G) {
    var h1 = document.getElementById('ptitle'); if (h1) h1.innerHTML = genTitle(G.title);
    if (!P.ownThree) {
      var th = document.getElementById('pthree');
      if (!th) { th = document.createElement('p'); th.className = 'pthree'; th.id = 'pthree'; h1.insertAdjacentElement('afterend', th); }
      th.innerHTML = threeLine(G.three);
    }
    var pd = document.getElementById('pdesc'); if (pd) pd.innerHTML = introHTML(G.intro);
    var pp = document.getElementById('ppoints'); if (pp) pp.outerHTML = '<ul class="ppoints">' + G.points.map(li).join('') + '</ul>';
    var pan = document.getElementById('ppanels'); if (pan) pan.innerHTML = genPanels();
    var ph = document.getElementById('pplace-host');
    if (ph && ((G.place && G.place.length) || G.tip)) ph.outerHTML = placeBand();
  }

  /* ---- the video slot: their metafield, or ?video=yt:ID / vimeo:ID to preview.
     Nothing renders without a film. */
  function parseVideo(t) {
    var m; if (!t) return null;
    if ((m = t.match(/^yt:([\w-]{6,})$/))) return { youtube: m[1] };
    if ((m = t.match(/^vimeo:(\d{5,})$/))) return { vimeo: m[1] };
    if ((m = t.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/))) return { youtube: m[1] };
    if ((m = t.match(/vimeo\.com\/(?:video\/)?(\d{5,})/))) return { vimeo: m[1] };
    if (/\.(mp4|webm|mov)(\?|$)/i.test(t)) return { src: t };
    return null;
  }
  var vh = document.getElementById('pvid-host');
  var GV = (G && G.video) || parseVideo(vh && vh.getAttribute('data-video'))
        || parseVideo(decodeURIComponent((location.search.match(/[?&]video=([^&]*)/) || [, ''])[1]));
  if (vh && GV) {
    var t = vh.getAttribute('data-title') || 'Heather';
    var poster = GV.poster || (GV.youtube ? 'https://i.ytimg.com/vi/' + encodeURIComponent(GV.youtube) + '/hqdefault.jpg' : '');
    vh.outerHTML = '<div class="pvid"><span class="eyebrow">' + esc(t) + '</span>'
      + '<div class="vslot" id="pvslot">' + (poster ? '<img src="' + poster + '" alt="" loading="lazy" decoding="async">' : '')
      + '<button class="vp" type="button" aria-label="Play: ' + esc(t) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l13-7.5z"/></svg></button></div>'
      + (GV.caption ? '<p class="vcap">' + esc(GV.caption) + '</p>' : '') + '</div>';
    var pvp = document.querySelector('#pvslot .vp');
    if (pvp) pvp.addEventListener('click', function () {
      var el, box = document.getElementById('pvslot');
      if (GV.youtube) {
        el = document.createElement('iframe');
        el.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(GV.youtube) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      } else if (GV.vimeo) {
        el = document.createElement('iframe');
        el.src = 'https://player.vimeo.com/video/' + encodeURIComponent(GV.vimeo) + '?autoplay=1&dnt=1';
        el.allow = 'autoplay; fullscreen; picture-in-picture';
      } else if (GV.src) {
        el = document.createElement('video');
        el.src = GV.src; el.controls = true; el.autoplay = true; el.playsInline = true;
        if (poster) el.poster = poster;
      }
      if (!el) return;
      if (el.tagName === 'IFRAME') { el.setAttribute('allowfullscreen', ''); el.title = t; }
      box.innerHTML = ''; box.appendChild(el); box.classList.add('playing');
    });
  } else if (vh) vh.remove();

  /* ---- the gallery: thumbnails swap the frame, arrow keys walk the row */
  var gal = host.querySelector('.pgal');
  if (gal) {
    var main = document.getElementById('pmain');
    var thumbs = [].slice.call(gal.querySelectorAll('.pthumb'));
    /* Sept 23 (Sara): a video thumbnail lifts its player into the frame instead of swapping a photograph in.
       The players are rendered by the section and parked in .pplayers; only one is ever in the frame. */
    var players = host.querySelector('.pplayers');
    var frameEl = main ? main.parentNode : null;
    function parkPlayer() {
      if (!players || !frameEl) return;
      var live = frameEl.querySelector('[data-mi]');
      if (!live) return;
      var v = live.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
      players.appendChild(live);
      main.hidden = false;
    }
    function showPlayer(i, b) {
      if (!players || !frameEl) return false;
      var node = players.querySelector('[data-mi="' + i + '"]');
      if (!node) return false;
      parkPlayer();
      main.hidden = true;
      frameEl.classList.remove('swapping');
      frameEl.classList.add('pshot-v');
      frameEl.appendChild(node);
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === thumbs.indexOf(b) ? 'true' : 'false'); });
      return true;
    }
    var show = function (i) {
      var b = thumbs[i]; if (!b) return;
      var mi = b.getAttribute('data-mi');
      if (mi !== null) { showPlayer(mi, b); return; }
      parkPlayer();
      frameEl.classList.remove('pshot-v');
      var src = b.getAttribute('data-src');
      if (main.getAttribute('src') === src) { b.focus(); return; }
      var frame = main.parentNode;
      frame.classList.add('swapping');
      if (G) frame.classList.toggle('photo', i > 0);
      var pre = new Image(), done = false;
      function swap() {
        if (done) return; done = true;
        main.src = src; main.removeAttribute('srcset');
        requestAnimationFrame(function () { frame.classList.remove('swapping'); });
      }
      pre.onload = swap; pre.onerror = swap; pre.src = src;
      if (pre.complete) swap();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    };
    /* Sept 30 (Sara): "is it easy to be able to swipe through product photos on mobile?" Below 1000px the
       stack is laid out as a snap track and IS the gallery, so a thumbnail scrolls that track instead of
       swapping the frame - the frame is not on screen there. Which mode we are in is read off the stack's
       own computed display rather than a breakpoint repeated in here, so the CSS stays the one authority. */
    var track = host.querySelector('.pstack');
    function swiping() { return !!track && getComputedStyle(track).display === 'flex'; }
    function slides() { return [].slice.call(track.children); }
    function goTo(i) {
      var sl = slides()[i]; if (!sl) return;
      track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    if (track) {
      var tick;
      track.addEventListener('scroll', function () {
        if (!swiping()) return;
        clearTimeout(tick);
        tick = setTimeout(function () {
          var sl = slides(), mid = track.scrollLeft + track.clientWidth / 2, best = 0, gap = Infinity;
          sl.forEach(function (el, n) {
            var c = el.offsetLeft - track.offsetLeft + el.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < gap) { gap = d; best = n; }
          });
          thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === best ? 'true' : 'false'); });
          var cur = thumbs[best];
          if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, 90);
      }, { passive: true });
    }

    gal.addEventListener('click', function (e) {
      var b = e.target.closest('.pthumb'); if (!b) return;
      if (swiping()) { goTo(thumbs.indexOf(b)); return; }
      show(thumbs.indexOf(b));
    });
    gal.addEventListener('keydown', function (e) {
      var i = thumbs.indexOf(document.activeElement.closest('.pthumb'));
      if (i < 0) return;
      var step = swiping() ? goTo : show;
      if (e.key === 'ArrowRight') { e.preventDefault(); var k = (i + 1) % thumbs.length; step(k); thumbs[k].focus(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); var j = (i - 1 + thumbs.length) % thumbs.length; step(j); thumbs[j].focus(); }
    });
  }

  /* ---- one selected variant, read by the price line and the bag */
  var psel = document.getElementById('psel');
  var add = document.getElementById('bigadd');
  var chosen = P.variantId;
  function pick() {
    if (!psel) return;
    var o = psel.options[psel.selectedIndex]; if (!o) return;
    chosen = Number(o.value);
    /* Sept 23: a marked-down size shows what it was. Sizes can differ - one on sale, the next not - so this is
       rebuilt per size rather than left as it rendered. Both strings come from Shopify's money filter. */
    var pr = document.getElementById('pprice');
    if (pr) { var was = o.getAttribute('data-was'), now = o.getAttribute('data-price');
      pr.textContent = now;
      if (was) pr.innerHTML = '<s class="em-was"></s><span class="em-now"></span>',
        pr.firstChild.textContent = was, pr.lastChild.textContent = now; }
    /* their Afterpay line quotes a quarter of the price: redraw it for this size */
    if (window.EM_AFTERPAY && o.getAttribute('data-cents')) { try { window.EM_AFTERPAY.config.amount = Number(o.getAttribute('data-cents')); window.EM_AFTERPAY.refresh(); } catch (e) {} }
    var ok = o.getAttribute('data-available') === 'true';
    if (add) { add.disabled = !ok; add.textContent = ok ? 'Add to Bag' : 'Sold out'; }
    try { var u = new URL(location.href); u.searchParams.set('variant', chosen); history.replaceState(null, '', u.toString()); } catch (e) {}
  }
  if (psel) psel.addEventListener('change', pick);
  /* arriving from a card's Add to Bag for a piece with several sizes in stock: the size picker is the next step */
  if (psel && /[?&]choose=1/.test(location.search)) {
    setTimeout(function () { try { psel.scrollIntoView({ block: 'center' }); psel.focus({ preventScroll: true }); } catch (e) {} }, 300);
  }

  var form = document.getElementById('pform');
  /* Their Rebuy cart takes product forms: it adds the item, opens its cart and stops the event at the form. So the
     form only keeps the page from leaving, and the page adds the item when the event still reaches the document,
     meaning nothing else took it (adding in both places put two in the bag). */
  if (form) form.addEventListener('submit', function (e) { if (window.EMCart) e.preventDefault(); });
  if (form) document.addEventListener('submit', function (e) {
    if (e.target !== form || !window.EMCart) return;
    e.preventDefault();
    if (!add || add.disabled) return;
    add.disabled = true;
    EMCart.add([{ id: chosen, quantity: 1 }]).then(function () {
      add.textContent = 'Added to bag'; add.classList.add('done');
      setTimeout(function () { add.textContent = 'Add to Bag'; add.classList.remove('done'); add.disabled = false; }, 1600);
    }).catch(function (err) {
      add.disabled = false; add.textContent = 'Add to Bag';
      alert(err && err.message ? err.message : 'Could not add to bag');
    });
  });

  /* ---- About this piece: the preview under the price is the opening of this
     same text, so its first paragraph would repeat it word for word. Cut the
     part the page has already said - a trim, not a rewrite. */
  var long = host.querySelector('#p-about .long');
  if (long) {
    var first = long.querySelector('p'), pre = String(long.getAttribute('data-preview') || '').replace(/\s+/g, ' ').trim();
    if (first && pre) {
      var norm = function (x) { return x.replace(/[’']/g, "'").replace(/[“”]/g, '"').replace(/\s+/g, ' ').toLowerCase(); };
      var t = first.textContent.replace(/\s+/g, ' ').trim();
      if (norm(t).indexOf(norm(pre)) === 0) {
        var rest = t.slice(pre.length).trim();
        if (rest) first.textContent = rest; else first.remove();
      } else if (norm(pre).indexOf(norm(t)) === 0) {
        first.remove(); /* the line under the price already holds all of this paragraph */
      }
    }
  }

  /* ---- Complete the practice, and Goes with this: Shopify's recommendations
     for this product, the ones in stock. "this plus this plus this, so they
     can create their own bundle" (Sara, Sept 9): the piece and its two
     companions, one button, the real sum. */
  /* Sept 14 (QA): what goes with a generator is not the other generators Shopify recommends: the ring that wears the
     frequency, the Formula it belongs to, and the copper (the prototype's genRelated, read from em-generators.js) */
  var FORMULA = { 'formula-home': 'harmonious-home-frequency-formula', 'formula-sleep': 'restorative-sleep-frequency-formula' };
  var ROOT = ((window.EM_ROUTES && EM_ROUTES.root) || '/').replace(/\/?$/, '/');
  function genSource() {
    var ids = [G.ring].concat(G.formulas || [], ['solid-copper-plate', 'copper-conductor', 'copper-spheres', 'copper-pyramid', 'frequency-generator-bag']).filter(Boolean);
    return Promise.all(ids.map(function (id) {
      var h = FORMULA[id] || ((window.EMBag && EMBag.handle) ? EMBag.handle(id) : id);
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) { return { products: list.filter(Boolean), gen: true }; });
  }
  function genLead() {
    var parts = ['Copper to set it on'];
    if (G.ring) parts.push('the ring that wears it');
    if ((G.formulas || []).length) parts.push('the Formula it belongs to');
    return parts.length === 1 ? parts[0] + '.' : parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] + '.';
  }
  /* ten, Shopify's most: "Add all three" now needs two companions that go straight in (independent check) */
  var recSource = G ? genSource() : (P.recs ? fetch(P.recs + '.json?product_id=' + P.id + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : { products: [] }; }) : null);
  if (recSource) recSource
    .then(function (d) {
      /* Sept 14 (QA): the variant a card or the bundle uses is one that can be bought, at its own price, and the
         photos come at the size they are shown (the recommendations send the originals) */
      function open1(r) { return (r.variants || []).filter(function (v) { return v.available; })[0]; }
      /* a card's price is the lowest among sizes in stock, as on every other card (snippets/em-live-price.liquid) */
      function low(r) { return Math.min.apply(null, (r.variants || []).filter(function (v) { return v.available; }).map(function (v) { return Number(v.price); })); }
      function sized(u, w) { u = String(u || ''); return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : u; }
      var recs = (d.products || []).filter(function (r) { return r.available && r.id !== P.id && open1(r); });
      var trio = document.getElementById('trio');
      /* Sept 14 (independent check): "Add all three" can't ask which size, so its companions are only pieces that go straight
         in by the site's one rule (snippets/em-choose.liquid): one variant in stock, or a quantity pack at one. It used to
         fall back to a piece with several sizes and add its first. Without two such companions there is no trio. */
      var mates = recs.filter(function (r) {
        var n = (r.variants || []).filter(function (v) { return v.available; }).length;
        var o = (r.options || [])[0]; o = String((o && (o.name || o)) || '').toLowerCase();
        return n === 1 || /#|number of|quantity/.test(o);
      }).slice(0, 2);
      if (trio && !P.soldOut && mates.length >= 2) {
        var mateItems = mates.map(function (m) {
          var v = open1(m); return { title: m.title, url: m.url, img: sized(m.featured_image, 240), price: v.price, vid: v.id }; });
        /* Sept 15 (independent check): the piece itself is whatever size is chosen now. The block used to keep the size the
           page opened with, so after choosing L its total and its add were still S's. */
        var current = function () {
          var o = psel && psel.options[psel.selectedIndex];
          var mine = (P.variants || []).filter(function (v) { return String(v.id) === String(chosen); })[0];
          return { price: mine ? mine.price : P.price, vid: chosen, ok: o ? o.getAttribute('data-available') === 'true' : true };
        };
        trio.innerHTML = '<span class="tk">Complete the practice</span>'
          + '<div class="trow">' + [{ title: P.title, url: P.url, img: P.img }].concat(mateItems).map(function (m, i) {
              return (i ? '<span class="plus" aria-hidden="true">+</span>' : '')
                + '<a class="tm" href="' + esc(m.url) + '"><img src="' + esc(m.img) + '" alt="' + esc(m.title) + '" loading="lazy"><span>' + esc(m.title) + '</span></a>'; }).join('')
          + '</div><div class="tbuy"><button class="tadd" type="button">Add all three</button><span class="ttotal"></span></div>';
        trio.hidden = false;
        var tadd = trio.querySelector('.tadd'), ttotal = trio.querySelector('.ttotal');
        var sync = function () {
          var me = current();
          ttotal.textContent = money(mateItems.reduce(function (s, m) { return s + Number(m.price); }, Number(me.price)));
          if (!tadd.classList.contains('done')) tadd.disabled = !me.ok;
        };
        sync();
        if (psel) psel.addEventListener('change', sync);
        tadd.addEventListener('click', function () {
          var me = current();
          if (!window.EMCart || !me.ok) return;
          tadd.disabled = true;
          EMCart.add([{ id: me.vid, quantity: 1 }].concat(mateItems.map(function (m) { return { id: m.vid, quantity: 1 }; }))).then(function () {
            tadd.textContent = 'Added all three'; tadd.classList.add('done');
            setTimeout(function () { tadd.textContent = 'Add all three'; tadd.classList.remove('done'); sync(); }, 1800);
          }).catch(function (err) {
            sync();
            if (window.EMBag && EMBag.toast) EMBag.toast(err && err.message ? err.message : 'Could not add all three');
          });
        });
      }
      var rel = recs.slice(0, 4), wrap = document.getElementById('relwrap');
      if (rel.length && wrap) {
        wrap.hidden = false;
        if (d.gen) {
          var rg = document.getElementById('rel'); rg.classList.add('gen');
          var rh = rg.parentNode.querySelector('h2');
          if (rh && !rg.parentNode.querySelector('.rlead')) rh.insertAdjacentHTML('afterend', '<p class="rlead">' + genLead() + '</p>');
        }
        document.getElementById('rel').innerHTML = rel.map(function (r) {
          return '<a class="rcard" href="' + esc(r.url) + '"><span class="shot"><img src="' + esc(sized(r.featured_image, 400)) + '" alt="" loading="lazy"></span>'
            + '<span class="n">' + esc(r.title) + '</span><span class="p">' + money(low(r)) + '</span></a>'; }).join('');
      }
      if (window.EM_DEPTH_PASS) window.EM_DEPTH_PASS();
    }).catch(function () {});
})();
